export const navigateToUrl = (url: string): void => window.location.assign(url);

export const reloadPage = () => window.location.reload();

export const replaceUrl = (url: string) => window.location.replace(url);
